/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * types of resources
 */
export type MediaTypeInput = (typeof MediaTypeInput)[keyof typeof MediaTypeInput];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaTypeInput = {
  document: 'document',
  video: 'video',
  audio: 'audio',
  jupyter_notebook: 'jupyter_notebook',
  link: 'link',
  archive: 'archive',
} as const;
